import {
  ThemeFontSizeDefinition,
  ThemeFontSizeName,
  ThemeFontSizeNameDesktop,
  ThemeFontSizeNameMobile,
} from '../../font.model';
import { M3TypeScale } from '../../base/config/m3-type-scale';

const FontSizesDesktop: Record<ThemeFontSizeNameDesktop, ThemeFontSizeDefinition> = {
  'headline-1': ['3.25rem', { lineHeight: '4rem', letterSpacing: '-1px' }],
  'headline-2': ['2.875rem', { lineHeight: '3.5rem', letterSpacing: 'normal' }],
  'headline-3': ['2.5rem', { lineHeight: '3.5rem', letterSpacing: 'normal' }],
  'headline-4': ['2.25rem', { lineHeight: '3rem', letterSpacing: 'normal' }],
  'headline-5': ['2rem', { lineHeight: '2.5rem', letterSpacing: 'normal' }],
  'headline-6': ['1.75rem', { lineHeight: '2.5rem', letterSpacing: 'normal' }],
  'body-1': ['1rem', { lineHeight: '1.5rem', letterSpacing: '1px' }],
  'body-2': ['0.875rem', { lineHeight: '1rem', letterSpacing: '1px' }],
  'body-3': ['0.75rem', { lineHeight: '1rem', letterSpacing: '1px' }],
  'body-4': ['0.625rem', { lineHeight: '1rem', letterSpacing: '1px' }],
};

const FontSizesMobile: Record<ThemeFontSizeNameMobile, ThemeFontSizeDefinition> = {
  'headline-1-m': ['2rem', { lineHeight: '2.5rem', letterSpacing: 'normal' }],
  'headline-2-m': ['1.75rem', { lineHeight: '2.5rem', letterSpacing: 'normal' }],
  'headline-3-m': ['1.5rem', { lineHeight: '2rem', letterSpacing: 'normal' }],
  'headline-4-m': ['1.25rem', { lineHeight: '1.5rem', letterSpacing: 'normal' }],
  'headline-5-m': ['1.125rem', { lineHeight: '1.5rem', letterSpacing: 'normal' }],
  'headline-6-m': ['1rem', { lineHeight: '1.5rem', letterSpacing: 'normal' }],
  'body-1-m': ['1rem', { lineHeight: '1.375rem', letterSpacing: 'normal' }],
  'body-2-m': ['0.875rem', { lineHeight: '1.25rem', letterSpacing: 'normal' }],
  'body-3-m': ['0.75rem', { lineHeight: '1rem', letterSpacing: 'normal' }],
  'body-4-m': ['0.625rem', { lineHeight: '0.875rem', letterSpacing: 'normal' }],
};

export const FontSizes: Record<ThemeFontSizeName, ThemeFontSizeDefinition> = {
  ...M3TypeScale,
  ...FontSizesDesktop,
  ...FontSizesMobile,
};
